var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H8C8 2.44772 7.55228 2 7 2V3ZM17 3V2C16.4477 2 16 2.44772 16 3H17ZM5 4H7V2H5V4ZM4 5C4 4.44772 4.44772 4 5 4V2C3.34315 2 2 3.34315 2 5H4ZM4 21V5H2V21H4ZM5 22C4.44771 22 4 21.5523 4 21H2C2 22.6569 3.34315 24 5 24V22ZM19 22H5V24H19V22ZM20 21C20 21.5523 19.5523 22 19 22V24C20.6569 24 22 22.6569 22 21H20ZM20 5V21H22V5H20ZM19 4C19.5523 4 20 4.44772 20 5H22C22 3.34315 20.6569 2 19 2V4ZM17 4H19V2H17V4ZM16 3C16 3.55228 15.5523 4 15 4V6C16.6569 6 18 4.65685 18 3H16ZM15 4H9V6H15V4ZM9 4C8.44772 4 8 3.55228 8 3H6C6 4.65685 7.34315 6 9 6V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10L16 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L16 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18L14 18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3V3C17 4.10457 16.1046 5 15 5H9C7.89543 5 7 4.10457 7 3V3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitInactive);
export default __webpack_public_path__ + "static/media/unit-inactive.d4ef60c2cefc3d7ea07a37530777eecf.svg";
export { ForwardRef as ReactComponent };